export const transactionHistoryItemTemplate = `
<div class="transaction w-100 border-bottom"><div class="ml-1 mr-1 mt-2"><div class="text-left m-0">{{ description }}</div><p class="text-left transaction-date m-0">{{ datePipe transactionDate format='dd-MM-yyyy' }} at {{ datePipe transactionDate format='shortTime' }}</p></div><div class="is-right"><div class="text-right m-0">{{ currencyPipe amount currencyCode=currency display='symbol-narrow' }}</div></div></div>
`;
export const quickLinkTemplate = `
See More
`;

export const titleTemplate = `
Transactions
`;
